/* ==========================================
   BUYERSUPPORT.JSX - SUPPORT TICKET SYSTEM
   Estate Experts - Buyer Support Component
   Updated: Modal form, Details left, Tickets right
   ========================================== */

import React, { useContext, useEffect, useState } from "react";
import {
  FaEdit,
  FaEllipsisV,
  FaPaperclip,
  FaPaperPlane,
  FaFilePdf,
  FaImage,
  FaDownload,
  FaTimes,
  FaPlus,
  FaUserShield,
} from "react-icons/fa";
import "../../../assets/css/Buyer/dashboard/buyersupport/buyersupport.css";
import BuyerMasterLayout from "../../../layouts/BuyerMasterLayout";
import AppContext from "context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";

const BuyerSupport = () => {
  // ====== STATE MANAGEMENT ======
  const [activeTicket, setActiveTicket] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [subject, setSubject] = useState();
  const [category, setCategory] = useState();
  const [property, setProperty] = useState();
  const [description, setDescription] = useState();
  const [replyMessage, setReplyMessage] = useState("");
  const [replyAttachments, setReplyAttachments] = useState([]);
  const [conversation, setConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [conversationIDForChat, setConversationIDForChat] = useState();
  const { loggedInBuyer, baseUrl, authToken } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [conversationLoading, setConversationLoading] = useState(false);
  // ====== DUMMY DATA - Tickets ======
  const [tickets, setTickets] = useState([]);

  // ====== CATEGORY OPTIONS ======
  const categories = [
    "Property Issue",
    "Visit / Appointment",
    "Payment / Booking",
    "Seller Communication",
    "Account / Login",
    "Other",
  ];

  // ====== MODAL HANDLERS ======
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // setCategory('')
  };

  const fetchAllTickets = () => {
    setLoading(true);
    console.log(loggedInBuyer);
    const formData = new FormData();
    formData.append("exbuyer_id", loggedInBuyer.id);

    axios
      .post(`${baseUrl}/buyer/helpsupport/fetchAllTickets`, formData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((res) => {
        console.log("All tickets", res.data);
        if (res.data.success == true) {
          setTickets(res.data.tickets);

        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const submitTicket = () => {
    console.log(
      "Submit Ticket",
      subject,
      category,
      description,
      property,
    );

    if (!subject || !category || !description) {
      alert("Please fill all required fields!");
      return;
    }

    const formData = new FormData();
    formData.append("exbuyer_id", loggedInBuyer.id);
    formData.append("subject", subject);
    formData.append("category", category);
    formData.append("description", description);
    formData.append("exproperty_id", property);
    formData.append("raisedby", "buyer");
    formData.append("against", "seller");

    axios
      .post(`${baseUrl}/buyer/helpsupport/createTicket`, formData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          Swal.fire({
            icon: "success",
            title: "Okay",
            confirmButtonText: "success",
          });
          fetchAllTickets();
          closeModal();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchConversation = (conversationId) => {
    if (!conversationId) {
      setConversation(null);
      setMessages([]);
      setConversationIDForChat(null);
      return;
    }

    setConversationLoading(true);

    const formData = new FormData();
    formData.append("exconversation_id", conversationId);

    axios
      .post(
        `${baseUrl}/buyer/helpsupport/fetchConversation`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      )
      .then((res) => {
        console.log("Support conversation:", res.data);

        if (res.data.success) {
          setConversation(res.data.conversation);
          setMessages(res.data.messages || []);
        } else {
          setConversation(null);
          setMessages([]);
        }
      })
      .catch((err) => {
        console.log("Support conversation error:", err);
        setConversation(null);
        setMessages([]);
      })
      .finally(() => {
        setConversationLoading(false);
      });
  };
  const sendMessage = () => {
    if (!conversationIDForChat) {
      Swal.fire({
        icon: "warning",
        title: "No Conversation",
        text: "Please select a ticket first.",
      });
      return;
    }

    if (!replyMessage.trim()) {
      return;
    }

    const formData = new FormData();

    formData.append(
      "exconversation_id",
      conversationIDForChat
    );

    formData.append(
      "message",
      replyMessage.trim()
    );

    axios
      .post(
        `${baseUrl}/buyer/helpsupport/sendMessage`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      )
      .then((res) => {
        console.log("Buyer support message:", res.data);

        if (res.data.success) {
          setReplyMessage("");

          fetchConversation(
            conversationIDForChat
          );
        }
      })
      .catch((err) => {
        console.log("Send support message error:", err);

        Swal.fire({
          icon: "error",
          title: "Message Not Sent",
          text:
            err.response?.data?.message ||
            "Something went wrong.",
        });
      });
  };
  const [properties, setProperties] = useState([]);

  const fetchProperties = () => {
    axios
      .get(`${baseUrl}/buyer/helpsupport/fetchAllProperties`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success) {
          setProperties(res.data.properties);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchAllTickets();
    fetchProperties();
  }, []);

  // ====== HANDLE REPLY ======
  const handleReplySubmit = (e) => {
    e.preventDefault();
    if (!replyMessage.trim()) return;

    console.log("Reply Sent:", {
      ticketId: activeTicket,
      message: replyMessage,
      attachments: replyAttachments,
    });

    alert("Reply sent successfully!");
    setReplyMessage("");
    setReplyAttachments([]);
  };

  const handleReplyFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setReplyAttachments([...replyAttachments, ...files]);
  };

  const removeReplyAttachment = (index) => {
    setReplyAttachments(replyAttachments.filter((_, i) => i !== index));
  };

  // ====== STATUS COLOR FUNCTION ======
  const getStatusClass = (status) => {
    switch (status) {
      case "Open":
        return "buyersupport-status-open";
      case "In Progress":
        return "buyersupport-status-progress";
      case "Resolved":
        return "buyersupport-status-resolved";
      case "Closed":
        return "buyersupport-status-closed";
      default:
        return "";
    }
  };



  // ====== SEND TO ADMIN HANDLER ======
  const handleSendToAdmin = () => {
    if (
      window.confirm(`Send ticket ${activeTicket} to admin for resolution?`)
    ) {
      console.log("Ticket sent to admin:", activeTicket);
      alert(
        "Ticket successfully sent to admin! You will receive a response soon.",
      );
    }
  };

  const currentTicket =
    tickets.find((ticket) => ticket.id === activeTicket) || null;
  return (
    <BuyerMasterLayout pageTitle="Support Ticket">
      {loading ? (

        <div className="buyersupport-loading">
          <div className="buyersupport-loader-wrapper">
            <div className="buyersupport-loader-spinner"></div>
          </div>

          <p className="buyersupport-loading-text">
            Loading your support tickets...
          </p>
        </div>

      ) : (
        <div className="buyersupport-page">
          <div className="buyersupport-container">
            {/* ==========================================
              RIGHT SIDEBAR - MY TICKETS LIST
          ========================================== */}
            <div className="buyersupport-sidebar">
              <div className="buyersupport-tickets-section">
                <div className="buyersupport-tickets-header">
                  <h2 className="buyersupport-section-title">My Tickets</h2>
                  <button
                    className="buyersupport-create-ticket-btn"
                    onClick={openModal}
                  >
                    <FaPlus /> Create Ticket
                  </button>
                </div>

                <div className="buyersupport-table">
                  {/* Table Header */}
                  <div className="buyersupport-table-header">
                    <div className="buyersupport-th">ID</div>
                    <div className="buyersupport-th">Subject</div>
                    <div className="buyersupport-th">Status</div>
                    <div className="buyersupport-th">Action</div>
                  </div>

                  {/* Table Rows */}
                  {tickets.map((ticket) => (
                    <div
                      key={ticket.id}
                      className={`buyersupport-table-row ${activeTicket === ticket.id ? "active" : ""}`}
                    >
                      <div className="buyersupport-td">{ticket.id}</div>
                      <div className="buyersupport-td">{ticket.subject}</div>
                      <div className="buyersupport-td">
                        <span
                          className={`buyersupport-status ${getStatusClass(ticket.status)}`}
                        >
                          {ticket.status}
                        </span>
                      </div>
                      <div className="buyersupport-td">
                        <button
                          onClick={() => {
                            setActiveTicket(ticket.id);

                            const conversationId =
                              ticket.exconversation?.id;

                            setConversationIDForChat(conversationId || null);

                            if (conversationId) {
                              fetchConversation(conversationId);
                            } else {
                              setConversation(null);
                              setMessages([]);
                            }
                          }}
                          className="buyersupport-view-btn"
                        >
                          View →
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* ==========================================
              LEFT SIDE - TICKET DETAILS
          ========================================== */}
            <div className="buyersupport-main">
              {currentTicket ? (
                <div className="buyersupport-details-section">
                  {/* Header */}
                  <div className="buyersupport-details-header">
                    <div className="buyersupport-details-title">
                      <h3>Ticket Details</h3>
                      <div className="buyersupport-header-actions">
                        <button className="buyersupport-icon-btn">
                          <FaEdit />
                        </button>
                        <button className="buyersupport-icon-btn">
                          <FaEllipsisV />
                        </button>
                      </div>
                    </div>

                    {/* Ticket Info Bar */}
                    <div className="buyersupport-ticket-info">
                      <div className="buyersupport-ticket-id">
                        <strong>Ticket ID: {currentTicket.id}</strong>
                        <span className="buyersupport-divider">|</span>
                        <span>{currentTicket.subject}</span>
                      </div>
                      <div className="buyersupport-ticket-meta">
                        <span
                          className={`buyersupport-status ${getStatusClass(currentTicket.status)}`}
                        >
                          Status: {currentTicket.status}
                        </span>
                        {/* <button 
                        className="buyersupport-send-admin-btn"
                        onClick={handleSendToAdmin}
                      >
                        <FaUserShield /> Send to Admin
                      </button> */}
                      </div>
                    </div>

                    {/* Progress Dots */}
                    <div className="buyersupport-progress-dots">
                      <span className="buyersupport-dot active"></span>
                      <span className="buyersupport-dot active"></span>
                      <span className="buyersupport-dot active"></span>
                      <span className="buyersupport-dot"></span>
                      <span className="buyersupport-dot"></span>
                      <span className="buyersupport-dot"></span>
                    </div>
                  </div>

                  {/* Conversation */}
                  <div className="buyersupport-conversation">
                    {messages.map((msg) => (
                      <div
                        key={msg.id}
                        className={`buyersupport-message ${msg.sender === "exbuyer"
                          ? "buyersupport-message-user"
                          : "buyersupport-message-support"
                          }`}
                      >
                        <div className="buyersupport-message-content">
                          <div className="buyersupport-message-header">
                            <strong>
                              {msg.sender === "exbuyer"
                                ? "You"
                                : "Support Team"}
                            </strong>
                          </div>

                          <p className="buyersupport-message-text">
                            {msg.massage}
                          </p>
                        </div>
                      </div>
                    ))}

                    {/* Shared Attachments */}
                    {currentTicket.sharedAttachments?.length > 0 && (
                      <div className="buyersupport-attachments">
                        {currentTicket.sharedAttachments.map((file, idx) => (
                          <div key={idx} className="buyersupport-attachment-item">
                            {file.type === "pdf" ? <FaFilePdf /> : <FaImage />}
                            <span className="buyersupport-attachment-name">
                              {file.name}
                            </span>
                            <button className="buyersupport-download-btn">
                              <FaDownload />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Reply Section */}
                  <div className="buyersupport-reply-input-wrapper">
                    <input
                      type="text"
                      placeholder="Add a Reply..."
                      value={replyMessage}
                      onChange={(e) => setReplyMessage(e.target.value)}
                      className="buyersupport-reply-input"
                    />
                    <label className="buyersupport-attach-btn">
                      <FaPaperclip />
                      <input
                        type="file"
                        multiple
                        onChange={handleReplyFileUpload}
                        style={{ display: "none" }}
                      />
                    </label>
                    <button onClick={() => {
                      sendMessage();
                    }} className="buyersupport-send-btn">
                      Send <FaPaperPlane />
                    </button>
                  </div>

                  {replyAttachments?.length > 0 && (
                    <div className="buyersupport-reply-attachments">
                      {replyAttachments.map((file, idx) => (
                        <div key={idx} className="buyersupport-reply-file">
                          <span>{file.name}</span>
                          <FaTimes onClick={() => removeReplyAttachment(idx)} />
                        </div>
                      ))}
                    </div>
                  )}
                  {/* <form
                  className="buyersupport-reply-section"
                  
                >
                  
                </form> */}
                </div>
              ) : (
                <div
                  className="buyersupport-details-section"
                  style={{ padding: "4rem", textAlign: "center" }}
                >
                  <h3>Select a ticket to view details</h3>
                </div>
              )}
            </div>
          </div>

          {/* ==========================================
            CREATE TICKET MODAL
        ========================================== */}
          {isModalOpen && (
            <div className="buyersupport-modal-overlay" onClick={closeModal}>
              <div
                className="buyersupport-modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="buyersupport-modal-header">
                  <h2 className="buyersupport-modal-title">Create New Ticket</h2>
                  <button
                    className="buyersupport-modal-close-btn"
                    onClick={closeModal}
                  >
                    <FaTimes />
                  </button>
                </div>

                <div className="buyersupport-modal-body">
                  <form className="buyersupport-form">
                    {/* Subject */}
                    <div className="buyersupport-form-group">
                      <label>Subject *</label>
                      <input
                        type="text"
                        name="subject"
                        placeholder="e.g. Payment Issue"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        required
                      />
                    </div>

                    {/* Category */}
                    <div className="buyersupport-form-group">
                      <label>Category *</label>
                      <select
                        name="category"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        required
                      >
                        <option value="">Select Category</option>
                        {categories.map((cat, idx) => (
                          <option key={idx} value={cat}>
                            {cat}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Related Property - Only show if category is NOT "Account / Login" */}
                    {category && category !== "Account / Login" && (
                      <div className="buyersupport-form-group buyersupport-form-group-animated">
                        <label>Related Property (Optional)</label>
                        <select
                          name="property"
                          value={property}
                          onChange={(e) => setProperty(e.target.value)}
                        >
                          <option value="">Select Property</option>
                          {properties.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.property_title}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* Description */}
                    <div className="buyersupport-form-group">
                      <label>Description *</label>
                      <textarea
                        name="description"
                        placeholder="Describe your issue in detail..."
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                      ></textarea>
                    </div>

                    {/* Submit Button */}
                    <button
                      type="button"
                      className="buyersupport-submit-btn"
                      onClick={submitTicket}
                    >
                      Submit Ticket
                    </button>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </BuyerMasterLayout>
  );
}

export default BuyerSupport;
